const enList = [
      { label: "Menu", isMainMenu: true }
       ,
      {
        label: "Home",
        icon: "mdi mdi-home-outline",
        url: "/home",
        bgcolor: "bg-primary",
        badgeValue: "2",
      } 
      ,
      {
        label: "Dashboard",
        icon: "mdi mdi-view-dashboard-variant-outline",
        url: "/dashboard",
        bgcolor: "bg-primary",
        badgeValue: "3",
      },
      {
         label: "QUESS-COMPOUND",
         icon: "compoundIcon",
         url: "/compound",
         issubMenubadge: true,
         bgcolor: "bg-primary",
      }, 
      {
        label: "QUESSCONTRÔLE",
        icon: "controleIcon",
        url: "/controle",
        issubMenubadge: true,
        bgcolor: "bg-primary",
      },
      {
        label: "QUESS-DOCS",
        icon: "docsIcon",
        url: "/docs",
        issubMenubadge: true,
        bgcolor: "bg-primary",
      },
   
      {
        label: "QUESS-LMS",
        icon: "lmsIcon",
        url: "/lms",
        issubMenubadge: true,
        bgcolor: "bg-primary",
      },
      {  label: "QUESS-LOGS",
        icon: "logsIcon",
        url: "/logs",
        issubMenubadge: true,
        bgcolor: "bg-primary",
      },
      {
    label: "Administration",
    icon: "mdi mdi-account-group",
    subItem: [
      { sublabel: "groupsManagement", link: "/groups-management" },
      { sublabel: "usersManagement", link: "/users-management" },
      { sublabel: "rolesManagement", link: "/roles-management" },
      { sublabel: "QuessCleanroomManagement", link: "/cleanroom-management" },
    ],
  },
    
]


const frList = [

   { label: "Menu", isMainMenu: true },
      {
        label: "Home",
        icon: "mdi mdi-home-outline",
        url: "/home",
        bgcolor: "bg-primary",
        badgeValue: "2",
      }, 
      {
        label: "Dashboard",
        icon: "mdi mdi-view-dashboard-variant-outline",
        url: "/dashboard",
        bgcolor: "bg-primary",
        badgeValue: "3",
      },
     {
        label: "QUESSCONTRÔLE",
        icon: "controleIcon",
        url: "/controle",
        issubMenubadge: true,
        bgcolor: "bg-primary",
    },
     {
        label: "QUESS-DOCS",
        icon: "docsIcon",
        url: "/docs",
        issubMenubadge: true,
        bgcolor: "bg-primary",
    },
      {
         label: "QUESS-COMPOUND",
         icon: "compoundIcon",
         url: "/compound",
         issubMenubadge: true,
         bgcolor: "bg-primary",
     }, 
    {   label: "QUESS-LOGS",
        icon: "logsIcon",
        url: "/logs",
        issubMenubadge: true,
        bgcolor: "bg-primary",
    } ,
   
    {
        label: "QUESS-LMS",
        icon: "lmsIcon",
        issubMenubadge: true,
        url: "/lms",
        bgcolor: "bg-primary",
    },
   {
    label: "Administration",
    icon: "mdi mdi-account-group",
    subItem: [
      { sublabel: "groupsManagement", link: "/groups-management" },
      { sublabel: "usersManagement", link: "/users-management" },
      { sublabel: "rolesManagement", link: "/roles-management" },
      { sublabel: "QuessCleanroomManagement", link: "/cleanroom-management" },
    ],
  }
    
]
const SidebarData =
 
 localStorage.getItem("lang") === "fr" ? frList : enList;

export default SidebarData;